import React from 'react';
import { Globe } from 'lucide-react';

const Navigation = () => {
  return (
    <nav className="fixed top-0 w-full bg-slate-900/80 backdrop-blur-md border-b border-slate-700 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg flex items-center justify-center">
              <Globe className="h-6 w-6 text-white" />
            </div>
            <span className="text-2xl font-bold text-white">HiveCluster.cloud</span>
          </div>
          <div className="hidden md:flex items-center space-x-8">
            <a href="#platform" className="text-slate-300 hover:text-white transition-colors">Platform</a>
            <a href="#agents" className="text-slate-300 hover:text-white transition-colors">Agents</a>
            <a href="#pricing" className="text-slate-300 hover:text-white transition-colors">Pricing</a>
            <a href="#docs" className="text-slate-300 hover:text-white transition-colors">Docs</a>
            <button className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white px-6 py-2 rounded-lg transition-all duration-200">
              Launch Platform
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
